import { render, staticRenderFns } from "./Shift.vue?vue&type=template&id=20e79713&scoped=true&"
import script from "./Shift.vue?vue&type=script&lang=js&"
export * from "./Shift.vue?vue&type=script&lang=js&"
import style0 from "./Shift.vue?vue&type=style&index=0&id=20e79713&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e79713",
  null
  
)

export default component.exports